// extracted by mini-css-extract-plugin
module.exports = {"orderTable":"orderCard_orderTable__j3F5H","productCard":"orderCard_productCard__25TK7","productImage":"orderCard_productImage__2VsMU"};